/** Trusted MSI operator access is granted only by the server-issued admin claim. */
export function hasMsiOperatorAccess(entitlement) {
  return entitlement?.isAdmin === true;
}

export function filterMsiOperatorItems(items, entitlement) {
  return items.filter((item) => !item.operator || hasMsiOperatorAccess(entitlement));
}
